<div>
  <div *ngFor="let data of filteredDataList()"> 
      <div>{{ data.value }}</div>
      @if(data.subItems.length > 0) {
        <app-quote-product-multi-select [dataList]="data.subItems"></app-quote-product-multi-select>
      }
  </div>
</div>
